const LEGACY_GAME_TYPE_MAP = {
  2: 9999, 3: 1, 4: 4, 5: 3, 6: 2,
  7: 5, 8: 8, 9: 9, 10: 4, 11: 7,
};

export function getGameTypeOptions(vm, options = {}) {
  const types = vm.$global.EGameType;
  const list = [
    [types.E_Slots, "GameTypeSlots"],
    [types.E_Table, "GameTypeTable"],
    [types.E_Live, "GameTypeLive"],
    [types.E_Arcade, "GameTypeArcade"],
    [types.E_Sport, "GameTypeSport"],
    [types.E_Esport, "GameTypeEsport"],
    [types.E_Lotto, "GameTypeLotto"],
    [types.E_Poker, "GameTypePoker"],
    [types.E_Other, "GameTypeOther"],
    [types.E_Fishing, "GameTypeFishing"],
    [types.E_Crypto, "GameTypeCrypto"],
    [types.E_Hash, "GameTypeHash"],
  ].map(([value, key]) => ({ value, label: vm.$t(key) }));
  if (options.allValue !== undefined) {
    list.unshift({ value: options.allValue, label: vm.$t("all") });
  }
  return list;
}

export function normalizeGameTypeSort(savedList, defaultList) {
  if (!Array.isArray(savedList) || savedList.length === 0) {
    return defaultList.map((item) => ({ ...item }));
  }
  // 新版中 10、11 分别是捕鱼和加密游戏，不能再仅凭编号判断为旧数据。
  // 旧版的 2 是哈希，10/11 的名称分别为 Up Down/彩票，可据此安全识别。
  const isLegacy = savedList.some((item) => {
    const id = Number(item.id);
    const name = String(item.name || "").trim().toLowerCase();
    return (
      (id === 2 && (name.includes("哈希") || name === "hash")) ||
      (id === 10 && (name === "up down" || name === "updown")) ||
      (id === 11 && (name.includes("彩票") || name === "lottery"))
    );
  });
  const normalized = [];
  const usedIds = new Set();
  savedList.forEach((item) => {
    const sourceId = Number(item.id);
    const id = isLegacy ? LEGACY_GAME_TYPE_MAP[sourceId] : sourceId;
    const definition = defaultList.find((option) => option.id === id);
    if (!definition || usedIds.has(id)) return;
    normalized.push({ ...definition, ...item, id, name: definition.name });
    usedIds.add(id);
  });
  defaultList.forEach((item) => {
    if (!usedIds.has(item.id)) normalized.push({ ...item });
  });
  return normalized;
}

const LEGACY_MINOR_TYPE_MAP = {
  1: 9999, 2: 1, 4: 3, 5: 4, 7: 5, 8: 2, 11: 7,
};

export function normalizeMinorGameSort(savedData, defaultData) {
  const saved = savedData && typeof savedData === "object" ? savedData : {};
  // 新版 11 是“加密游戏”，旧版 11 才是“彩票”，不能只按 key 判断。
  // 旧版 key=1 保存的是哈希玩法（数字 id），key=11 保存的是彩票玩法；
  // 新版厂商小类统一使用 gm_ag_* 形式的 id。
  const legacyHashItems = Array.isArray(saved["1"]) ? saved["1"] : [];
  const legacyLotteryItems = Array.isArray(saved["11"]) ? saved["11"] : [];
  const isLegacy =
    legacyHashItems.some((item) =>
      /^\d+$/.test(String(item.id || "")) || String(item.name || "").includes("哈希")
    ) ||
    legacyLotteryItems.some((item) => {
      const id = String(item.id || "").toLowerCase();
      const name = String(item.name || "").toLowerCase();
      return ["bpc", "ssc", "ttjsc", "pk10", "ks"].includes(id) ||
        name.includes("彩票") || name.includes("lottery");
    });
  const migrated = {};
  Object.keys(saved).forEach((key) => {
    const targetKey = isLegacy ? LEGACY_MINOR_TYPE_MAP[key] : Number(key);
    if (targetKey && !migrated[targetKey]) migrated[targetKey] = saved[key];
  });

  const result = {};
  Object.keys(defaultData).forEach((key) => {
    const defaults = defaultData[key] || [];
    const current = Array.isArray(migrated[key]) ? migrated[key] : [];
    const used = new Set();
    result[key] = [];
    current.forEach((savedItem) => {
      const item = defaults.find((option) =>
        String(option.id) === String(savedItem.id) || option.name === savedItem.name
      );
      if (!item || used.has(String(item.id))) return;
      result[key].push({
        ...item,
        state: Number(savedItem.state) === 1 ? 1 : 2,
      });
      used.add(String(item.id));
    });
    defaults.forEach((item) => {
      if (!used.has(String(item.id))) result[key].push({ ...item });
    });
  });
  return result;
}
